import View from '@components/navTab/view.vue';
const name = routerName => `d_${routerName}`;
import HycBulkShelves from '@/pages/hyc/bulkShelves.vue';
import HycBatchBulkShelves from '@/pages/hyc/batchBulkShelves.vue';
import HycGroupBulkShelves from '@/pages/hyc/groupBulkShelves.vue';

const hyc = {
  path: '/hyc',
  name: name('DistributorHyc'),
  redirect: '/hyc/bulkShelves',
  component: View,
  meta: {
    title: '货源池',
    icon: 'el-icon-caiwu1',
  },
  children: [
    {
      name: name('BulkShelves'),
      path: 'bulkShelves',
      component: HycBulkShelves,
      meta: {
        title: '一键铺货',
      },
    },
    {
        name: name('batchBulkShelves'),
        path: 'batchBulkShelves',
        component: HycBatchBulkShelves,
        meta: {
          title: '批量铺货',
        },
      },
    {
      name: name('HycGroupBulkShelves'),
      path: 'groupBulkShelves',
      component: HycGroupBulkShelves,
      meta: {
        title: '组合铺货',
      },
    },
  ],
};

export default hyc;
